import { useGetReportsQuery } from 'mmfintech-backend-api'

type UseAttentionNeededReportCountOutput = {
  count: number
  error: unknown
  isLoading: boolean
  isFetching: boolean
}

export const useAttentionNeededReportCount = (): UseAttentionNeededReportCountOutput => {
  const { totalElements, error, isLoading, isFetching } = useGetReportsQuery(
    {
      page: 0,
      size: 1,
      deleted: false,
      hideDraftReports: true,
      requiredAction: true
    },
    {
      selectFromResult: ({ data, ...rest }) => {
        const { totalElements } = data || {}
        return {
          totalElements,
          ...rest
        }
      }
    }
  )

  return {
    count: totalElements ?? 0,
    error,
    isLoading,
    isFetching
  }
}
